import React from 'react';

import { Box, Copy, DeleteWarning, Forms, Paging, SystemText } from 'e4shared';
import ManageNote from '../manageNote';
import { e4Format, e4Formats } from 'helpers/dates';

export const Notes = ({ profile, permissions, reload, deleteNote, notes, outerHeader, bullets }) => {
    const [showAddNote, setShowAddNote] = React.useState(false);
    const [note, setNote] = React.useState({});
    const [showDeleteNote, setShowDeleteNote] = React.useState(false);
    const [deleting, setDeleting] = React.useState(null);
    const [page, setPage] = React.useState(1);
    const [search, setSearch] = React.useState('');

    if (!profile || !permissions) return null;

    const searchNotes = search => {
        setPage(1);
        setSearch(search.toLowerCase());
    };

    const callDeleteNote = id => {
        const note = {
            id,
            profile_Id: profile.id,
        };

        setShowDeleteNote(true);
        setDeleting(note);
    };

    const deleteNoteConfirm = confirm => {
        setDeleting(null);
        setShowDeleteNote(false);
        if (confirm) {
            deleteNote(deleting);
        }
    };

    const pageSize = 5;
    const start = (page - 1) * pageSize;
    const end = start + pageSize;

    const filteredNotes = notes?.filter(
        (n, i) =>
            !search ||
            n.notes.toLowerCase().indexOf(search) >= 0 ||
            `${n.first_Name} ${n.last_Name}`.toLowerCase().indexOf(search) >= 0
    );

    const records = filteredNotes?.length;

    const mappedNotes = filteredNotes?.map((note, i) => {
        if (i < start || i >= end) return null;
        return (
            <div key={note.id} className="divider-row">
                <div className="row">
                    <div className="col-xs-12 hidden-md hidden-lg">
                        <h5>
                            <strong>{e4Format(note.added_Date, e4Formats.long)}</strong>
                        </h5>
                    </div>
                    <div className="col-md-6 hidden-xs hidden-sm">
                        <h5>
                            <strong>{e4Format(note.added_Date, e4Formats.long)}</strong>
                        </h5>
                    </div>
                    <div className="col-md-6 text-right pull-right hidden-xs hidden-sm mt10">
                        <span>{SystemText('User121/Notes/By', `${note.first_Name} ${note.last_Name}`)}</span>
                        {permissions?.one2ones?.canEditNote?.(note.added_By) && (
                            <button
                                title={SystemText('User121/Notes/Edit')}
                                onClick={() => {
                                    setShowAddNote(true);
                                    setNote(note);
                                }}
                                className="btn btn-xs btn-info ml10 mr1"
                            >
                                <i className="fa fa-pencil" />
                            </button>
                        )}
                        {permissions?.one2ones.canDeleteNote?.(note.added_By) && (
                            <button
                                title={SystemText('User121/Notes/Delete')}
                                onClick={() => callDeleteNote(note.id)}
                                className="btn btn-xs btn-danger"
                            >
                                <i className="fa fa-trash" />
                            </button>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Copy value={note.notes} />
                    </div>
                </div>
                {i !== notes.length - 1 && <hr className="hr-light" />}
            </div>
        );
    });

    const addNote = () =>
        permissions?.one2ones?.canAddNote ? (
            <button
                onClick={() => {
                    setShowAddNote(true);
                    setNote({ profile_Id: profile.id });
                }}
                className="btn text-sm btn-success pull-right"
            >
                {SystemText('User121/Notes/Add')}
            </button>
        ) : undefined;

    return (
        <div>
            {outerHeader && (
                <div className="flex flex-center mb10">
                    <h4 className="flex-grow">{SystemText('User121/Notes/Title')}</h4>
                    {addNote()}
                </div>
            )}
            <Box
                data-testid="user121-notes-box"
                title={outerHeader ? null : SystemText('User121/Notes/Title')}
                button={outerHeader ? null : addNote}
            >
                <div>
                    <div>
                        <Forms.Text
                            value={search}
                            onChange={searchNotes}
                            label={outerHeader ? null : SystemText('User121/Notes/Filter/Label')}
                            placeholder={SystemText('User121/Notes/Filter/Placeholder')}
                        />
                    </div>
                    {notes && notes.length > 0 ? mappedNotes : <div>{SystemText('User121/Notes/NoNotes')}</div>}
                    {notes && notes.length > 0 && records > pageSize && (
                        <div className="text-center mt20">
                            <Paging
                                goToPage={setPage}
                                pageSize={pageSize}
                                page={page}
                                recordCount={records}
                                bullets={bullets}
                            />
                        </div>
                    )}
                </div>
            </Box>
            <ManageNote
                note={{ ...note, profile_Id: profile.id }}
                show={showAddNote}
                reload={() => reload(profile.id)}
                close={() => setShowAddNote(false)}
            />
            <DeleteWarning
                message={SystemText('User121/Notes/Warning')}
                show={showDeleteNote}
                close={confirm => deleteNoteConfirm(confirm)}
            />
        </div>
    );
};

export default Notes;
